import {
  useReportCapabilitiesQuery,
  useCastwareAgentStatus,
} from '@cast/split-me/hooks';
import { useCluster } from '@cast/shared-cluster-context-data-access';

export type UseGpuPrerequisitesResult = {
  clusterId: string;
  hasGpuMetrics: boolean;
  hasGpuData: boolean;
  isDataProcessing: boolean;
  isGpuExporterInstalled: boolean;
  isCapabilitiesLoading: boolean;
  error: unknown;
  refetch: () => void;
};

type Params = {
  startTime: string;
  endTime: string;
};

export const useGpuPrerequisites = ({
  startTime,
  endTime,
}: Params): UseGpuPrerequisitesResult => {
  const { cluster } = useCluster();

  const {
    data: capabilities,
    isLoading: isCapabilitiesQueryLoading,
    error: capabilitiesError,
    refetch: refetchCapabilities,
  } = useReportCapabilitiesQuery({
    clusterId: cluster.id,
    startTime,
    endTime,
    enabled: !!cluster.id,
  });

  const {
    isLoading: isGpuExporterStatusLoading,
    isInstalled: isGpuExporterInstalled,
  } = useCastwareAgentStatus({
    name: 'castai-gpu-metrics-exporter',
  });

  const isCapabilitiesLoading =
    isCapabilitiesQueryLoading || isGpuExporterStatusLoading;

  return {
    clusterId: cluster.id,
    hasGpuMetrics: Boolean(capabilities?.gpuMetricsAvailable),
    hasGpuData: Boolean(capabilities?.gpuDataAvailable),
    isDataProcessing: Boolean(
      capabilities?.gpuDataReceived && !capabilities?.gpuDataAvailable
    ),
    isGpuExporterInstalled,
    isCapabilitiesLoading,
    error: capabilitiesError,
    refetch: () => {
      refetchCapabilities();
    },
  };
};
